import React from "react"
import {createRoot} from "react-dom/client"
import {BrowserRouter} from "react-router-dom"
import {datadogLogs} from "@datadog/browser-logs"

import {App} from "./App"
import {config} from "./config"

datadogLogs.init(config.datadogAuth)

createRoot(document.getElementById("root")!).render(
	<BrowserRouter>
		<App />
	</BrowserRouter>,
)
